<template>
  <material-card
    v-if="selectedPlan !== null && selectedPlan !== undefined && planIdentity!==null && planIdentity!== undefined"
    :title="$t('components.membersimportwizardcomponent.create_new_member')"
    :color="$vuetify.theme.themes.light.success"
    icon="add"
  >
    <v-card-text>
      <add-member-wizard
        :inDialog="true"
        ref="addMemberWizard"
        :headers="headers"
        @valid-changed="addMemberWizardValid = $event"
        @new-member-saved="
          if ($refs.table) {
            $refs.table.getDataAsync();
          } else {
            $router.push({
              name: 'members',
              params: { planId: selectedPlan.Id }
            });
          }
        "
      ></add-member-wizard>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        @click="
          $router.push({ name: 'members', params: { planId: selectedPlan.Id } });
        "
      >
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn
        :loading="$refs.addMemberWizard && $refs.addMemberWizard.saving"
        :disabled="!addMemberWizardValid"
        color="primary"
        @click="$refs.addMemberWizard.save()"
      >
        {{ $t("globals.finish") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import AddMemberWizard from "../components/AddMemberWizard";
import ErrorHandler from "../components/ErrorHandler";
import { mapActions, mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
export default {
  components: {
    AddMemberWizard,
    ErrorHandler,
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planIdentity"]),
  },
  mixins: [planSetter],
  data() {
    return {
      headers: null,
      error: null,
      addMemberWizardValid: true,
    };
  },

  methods: {
    ...mapActions("plansMembers", ["getMembersManagementColumns"]),
    async loadPlanData() {
      try {
        this.headers = (await this.getMembersManagementColumns(
          this.selectedPlan.Id
        )).data.sort((a, b) => {
          return a.order - b.order;
        });
      } catch (error) {
        this.error = error;
      }
    },
    async unload() {
      console.log("unload");
      try {
        await this.$refs.addMemberWizard.tryReleaseCertificate();
        console.log("Hello");
        this.sleep(1000);
        console.log("World!");
      } catch (error) {
        this.error = error;
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  created() {
    window.addEventListener("beforeunload", this.unload, {capture: true});
    // window.addEventListener('unload', this.unload, {capture: true});
    // document.addEventListener("visibilitychange",this.unload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unload, { capture: true });
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  async beforeRouteLeave(to, from, next) {
      try {
        await this.$refs.addMemberWizard.tryReleaseCertificate();
      } catch (error) {
        this.error = error;
      }
    next();
  },
};
</script>
